"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateExtractor = exports.planningResponseExtractor = void 0;
var planningResponseExtractor = function (response) {
    return response.service_plans;
};
exports.planningResponseExtractor = planningResponseExtractor;
var updateExtractor = function (response) { return response.service_plan; };
exports.updateExtractor = updateExtractor;
//# sourceMappingURL=ServicePlans.consts.js.map